<template>
  <div class="admin-services">
    <h2 class="page-title">Hizmet Sayfaları</h2>

    <!-- Yeni Hizmet Ekle -->
    <div class="new-form">
      <h3>Yeni Hizmet Ekle</h3>
      <input v-model="newPage.slug" placeholder="Slug (örnek: noter-tasdikli-ceviri)" />
      <input v-model="newPage.title_tr" placeholder="Türkçe Başlık" />
      <input v-model="newPage.title_en" placeholder="İngilizce Başlık" />
      <button @click="createPage">Ekle</button>
    </div>

    <!-- Liste -->
    <div class="service-list">
      <ul>
        <li v-for="page in pages" :key="page.slug">
          <div class="info">
            <strong>{{ page.title_tr }}</strong>
          </div>
          <button @click="selectPage(page)">Düzenle</button>
        </li>
      </ul>
    </div>

    <!-- Düzenleme Formu -->
    <div v-if="selectedPage" class="edit-form">
      <div class="form-header">
        <h3>{{ selectedPage.slug }} - Düzenle</h3>
        <span class="close-btn" @click="selectedPage = null">✕</span>
      </div>

      <label>Türkçe Başlık:</label>
      <input v-model="selectedPage.title_tr" class="title-input" />

      <label>İngilizce Başlık:</label>
      <input v-model="selectedPage.title_en" class="title-input" />

      <div class="tab-switch">
        <button @click="switchLang('tr')" :class="{ active: activeLang === 'tr' }">Türkçe</button>
        <button @click="switchLang('en')" :class="{ active: activeLang === 'en' }">English</button>
        <button @click="deletePage(selectedPage.slug)" class="danger-btn">Sil</button>
      </div>

      <label>İçerik ({{ activeLang.toUpperCase() }}):</label>
      <TipTapEditor v-model="content" :key="selectedPage?.slug + '-' + activeLang" />

      <button @click="updateContent" class="save-btn">Kaydet</button>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import axios from 'axios'
import TipTapEditor from '@/components/TipTapEditor.vue'

const pages = ref([])
const selectedPage = ref(null)
const content = ref('')
const activeLang = ref('tr')
const newPage = ref({ slug: '', title_tr: '', title_en: '' })
const token = localStorage.getItem('token')

const fetchPages = async () => {
  const res = await axios.get('/admin/services', {
    headers: { Authorization: `Bearer ${token}` }
  })
  pages.value = res.data
}

const selectPage = async (page) => {
  selectedPage.value = { ...page }
  activeLang.value = 'tr'
  await fetchContent(page.slug, 'tr')
}

const switchLang = async (lang) => {
  activeLang.value = lang
  if (selectedPage.value) {
    await fetchContent(selectedPage.value.slug, lang)
  }
}

const fetchContent = async (slug, lang) => {
  try {
    const res = await axios.get(`/admin/services/${slug}/content?lang=${lang}`, {
      headers: { Authorization: `Bearer ${token}` }
    })
    content.value = res.data.content || ''
  } catch (err) {
    console.error('İçerik alınamadı:', err)
    content.value = ''
  }
}

const updateContent = async () => {
  const { slug, title_tr, title_en } = selectedPage.value
  await axios.put(`/admin/services/${slug}`, {
    title_tr,
    title_en,
    lang: activeLang.value,
    content: content.value
  }, {
    headers: { Authorization: `Bearer ${token}` }
  })
  alert('Sayfa başarıyla güncellendi.')
  await fetchPages()
}

const createPage = async () => {
  if (!newPage.value.slug || !newPage.value.title_tr || !newPage.value.title_en) {
    alert('Tüm alanları doldurun.')
    return
  }

  await axios.post('/admin/services', newPage.value, {
    headers: { Authorization: `Bearer ${token}` }
  })

  alert('Yeni hizmet eklendi.')
  newPage.value = { slug: '', title_tr: '', title_en: '' }
  await fetchPages()
}

const deletePage = async (slug) => {
  if (!confirm('Bu hizmeti silmek istediğinizden emin misiniz?')) return
  await axios.delete(`/admin/services/${slug}`, {
    headers: { Authorization: `Bearer ${token}` }
  })
  alert('Hizmet silindi.')
  selectedPage.value = null
  await fetchPages()
}

onMounted(fetchPages)
</script>

<style scoped>
.admin-services {
  max-width: 1100px;
  margin: 40px auto;
  padding: 30px;
  background-color: rgba(255, 255, 255, 0.95);
  border-radius: 16px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  color: #222;
}

.page-title {
  font-size: 28px;
  font-weight: 600;
  text-align: center;
  margin-bottom: 30px;
  color: #222;
}

/* Yeni hizmet formu */
.new-form {
  background-color: #f9f9f9;
  padding: 20px;
  margin-bottom: 30px;
  border-radius: 12px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.06);
  color: #222;
}

.new-form input {
  display: block;
  width: 100%;
  margin: 8px 0;
  padding: 10px;
  border-radius: 6px;
  border: 1px solid #ccc;
  font-size: 15px;
  color: #222;
}

.new-form button {
  padding: 10px 20px;
  background-color: #2ecc71;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-weight: bold;
}

.new-form button:hover {
  background-color: #27ae60;
}

/* Liste */
.service-list ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.service-list li {
  background: white;
  border: 1px solid #ddd;
  border-radius: 10px;
  margin-bottom: 12px;
  padding: 12px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
  color: #222;
}

.service-list .info strong {
  color: #222;
}

.service-list button {
  background-color: #3498db;
  color: white;
  padding: 6px 14px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
}

.service-list button:hover {
  background-color: #2980b9;
}

/* Düzenleme formu */
.edit-form {
  margin-top: 40px;
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
  padding: 24px;
  position: relative;
  color: #222;
}

.form-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.close-btn {
  font-size: 18px;
  cursor: pointer;
  background: #e74c3c;
  color: white;
  padding: 6px 10px;
  border: none;
  border-radius: 50%;
}

.title-input {
  width: 100%;
  padding: 10px;
  margin-bottom: 14px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 15px;
  color: #222;
}

.save-btn {
  background-color: #2ecc71;
  color: white;
  padding: 10px 20px;
  font-weight: bold;
  border: none;
  border-radius: 6px;
  cursor: pointer;
}

.save-btn:hover {
  background-color: #27ae60;
}

.tab-switch {
  display: flex;
  gap: 10px;
  margin: 16px 0;
}

.tab-switch button {
  padding: 6px 14px;
  border: 1px solid #ccc;
  background: #eee;
  border-radius: 6px;
  cursor: pointer;
}

.tab-switch button.active {
  background: #3498db;
  color: white;
  font-weight: bold;
}

.danger-btn {
  background-color: #e74c3c;
  color: white;
  border: none;
  padding: 6px 12px;
  border-radius: 6px;
  margin-left: auto;
}

.danger-btn:hover {
  background-color: #c0392b;
}

.ProseMirror {
  color: #222 !important;
}

/* Responsive */
@media (max-width: 768px) {
  .admin-services {
    padding: 20px;
    margin: 20px 10px;
  }

  .page-title {
    font-size: 22px;
  }

  .edit-form {
    padding: 16px;
  }

  .form-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }

  .tab-switch {
    flex-direction: column;
    gap: 8px;
  }

  .danger-btn {
    width: 100%;
    margin-left: 0;
  }
}
</style>
